import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import Reveal from "@/components/Reveal";

const FAQS = [
  {
    q: "What file formats do you accept?",
    a: "STL and STEP are ideal. We also work with OBJ, 3MF, DXF and even hand-drawn sketches — the AI assistant can help you decide if we need to model it first.",
  },
  {
    q: "How long does a typical print take?",
    a: "Simple parts often ship within 24 hours. Multi-piece robotics or large decor pieces typically run 24–72 hours. We give you a firm ETA with the quote.",
  },
  {
    q: "Which materials should I choose?",
    a: "PLA for detail/decor, PETG for outdoor/functional parts, ABS for heat-tolerant mechanical builds, Nylon-CF for structural strength, Silk-PLA for premium finishes, and SLA resin for micro-detail miniatures.",
  },
  {
    q: "Do you deliver outside Bengaluru?",
    a: "Yes — Bengaluru pickup and courier delivery are available, and we ship pan-India via Delhivery (typically 2–4 days). Insurance is added for higher-value parts on request.",
  },
  {
    q: "What is the minimum order value?",
    a: "There's no minimum — we happily print a single ₹80 keychain or a 60-piece robotics batch. Student projects get a 10% loyalty discount on their second order.",
  },
  {
    q: "Do you sign NDAs for startup prototypes?",
    a: "Absolutely. Mutual NDAs are standard for prototype work — just mention it on WhatsApp and we'll send our template over.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 sm:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <Reveal>
            <span className="label-overline">/ 06 — FAQ</span>
            <h2 className="font-display text-4xl sm:text-5xl mt-6 leading-[1.05] font-semibold tracking-tight">
              Everything you<br />wanted to ask.
            </h2>
            <p className="text-zinc-400 leading-relaxed mt-6">
              Can't find your answer? WhatsApp us — real humans reply within a
              few hours during studio hours.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <div className="border-t border-white/10">
            {FAQS.map((f, i) => {
              const isOpen = open === i;
              return (
                <Reveal key={f.q} delay={i * 60}>
                  <div className="border-b border-white/10" data-testid={`faq-item-${i}`}>
                    <button
                      data-testid={`faq-toggle-${i}`}
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      className="w-full flex items-center justify-between text-left py-5 gap-6 group"
                    >
                      <span className={`font-display text-lg sm:text-xl transition-colors ${isOpen ? "text-white" : "text-zinc-300 group-hover:text-white"}`}>
                        {f.q}
                      </span>
                      <span className={`shrink-0 w-9 h-9 grid place-items-center border transition-all duration-300 ${isOpen ? "border-[#FF5722] bg-[#FF5722] text-white rotate-90" : "border-white/15 text-zinc-400"}`}>
                        {isOpen ? <Minus size={14} /> : <Plus size={14} />}
                      </span>
                    </button>
                    <div
                      className="grid transition-all duration-500 ease-out"
                      style={{
                        gridTemplateRows: isOpen ? "1fr" : "0fr",
                      }}
                    >
                      <div className="overflow-hidden">
                        <p className="text-zinc-400 text-sm leading-relaxed pb-6 pr-14">
                          {f.a}
                        </p>
                      </div>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
